import { actionCreator } from 'utils';
import * as StatisticsTypes from '../types/statisticType';

const initState = {
    statisticsListing: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
    },
    statisticsGroups: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
    },
    exportsListing: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
    },
    invoice: {
        loading: false,
        error: false,
        data: null,
        offset: 0,
        limit: 50,
        sort: '',
        filters: {
            invoiceNumber: '',
            customerNumber: '',
            orderNumber: '',
            company: '',
            clientName: '',
            daysOpen: '',
            timeLimit: '',
            createdAt: [],
            paymentStatus: undefined,
            ogm: '',
            vatNumber: '',
            billingAccount: '',
            isProforma: false,
        },
        orders: {
            loading: false,
            data: null,
        },
        exportInvoices: {
            loading: false,
            error: false,
        },
    },
};

export default function reducer(state = initState, action) {
    switch (action.type) {
    case StatisticsTypes.EXPORT_STATISTICS_GROUPS:
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                loading: true,
                error: false,
            },
        });

    case actionCreator(StatisticsTypes.EXPORT_STATISTICS_GROUPS, 'res'):
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                loading: false,
                data: action.data,
            },
        });


    case actionCreator(StatisticsTypes.EXPORT_STATISTICS_GROUPS, 'err'):
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                loading: false,
                error: true,
            },
        });

    case StatisticsTypes.SET_STATISTICS_EXPORTS_PAGINATION:
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                [action.key]: action.pagination,
            },
        });

    case StatisticsTypes.LOAD_STATISTICS_EXPORTS:
        return Object.assign({}, state, {
            exportsListing: {
                ...state.exportsListing,
                loading: true,
                error: false,
            },
        });


    case StatisticsTypes.LOAD_STATISTICS_GROUPS:
        return Object.assign({}, state, {
            statisticsGroups: {
                ...state.statisticsGroups,
                loading: true,
                error: false,
            },
        });

    case actionCreator(StatisticsTypes.LOAD_STATISTICS_GROUPS, 'res'):
        return Object.assign({}, state, {
            statisticsGroups: {
                ...state.statisticsGroups,
                loading: false,
                data: action.data,
            },
        });


    case actionCreator(StatisticsTypes.LOAD_STATISTICS_GROUPS, 'err'):
        return Object.assign({}, state, {
            statisticsGroups: {
                ...state.statisticsGroups,
                loading: false,
                error: true,
            },
        });

        // I N V O I C E

    case StatisticsTypes.LOAD_STATISTICS_INVOICE:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                loading: true,
                error: false,
            },
        });

    case actionCreator(StatisticsTypes.LOAD_STATISTICS_INVOICE, 'res'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                loading: false,
                data: action.data,
            },
        });


    case actionCreator(StatisticsTypes.LOAD_STATISTICS_INVOICE, 'err'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                loading: false,
                error: true,
                orders: {
                    ...state.invoice.orders,
                    loading: false,
                },
            },
        });

    case StatisticsTypes.SET_STATISTICS_INVOICE_PAGINATION:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                [action.key]: action.pagination,
            },
        });

    case StatisticsTypes.LOAD_STATISTICS_INVOICE_ORDERS:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                orders: {
                    ...state.invoice.orders,
                    loading: true,
                },
            },
        });

    case actionCreator(StatisticsTypes.LOAD_STATISTICS_INVOICE_ORDERS, 'res'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                orders: {
                    data: action.data,
                    loading: false,
                },
            },
        });

    case actionCreator(StatisticsTypes.LOAD_STATISTICS_INVOICE_ORDERS, 'err'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                orders: {
                    ...state.invoice.orders,
                    loading: false,
                },
            },
        });

    case StatisticsTypes.SET_STATISTICS_INVOICE_SORT:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                sort: action.sort,
            },
        });

    case StatisticsTypes.SET_STATISTICS_INVOICE_FILTERS:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                filters: {
                    ...state.invoice.filters,
                    [action.key]: action.value,
                },
            },
        });

    case StatisticsTypes.RESET_STATISTICS_INVOICE_FILTERS:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                filters: initState.invoice.filters,
            },
        });

    case StatisticsTypes.EXPORT_INVOICES:
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                exportInvoices: {
                    ...state.invoice.exportInvoices,
                    loading: true,
                },
            },
        });

    case actionCreator(StatisticsTypes.EXPORT_INVOICES, 'res'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                exportInvoices: {
                    ...state.invoice.exportInvoices,
                    error: false,
                    loading: false,
                },
            },
        });

    case actionCreator(StatisticsTypes.EXPORT_INVOICES, 'err'):
        return Object.assign({}, state, {
            invoice: {
                ...state.invoice,
                exportInvoices: {
                    ...state.invoice.exportInvoices,
                    error: true,
                    loading: false,
                },
            },
        });

        // I N V O I C E
    default:
        return state;
    }
}
